import { Component, Input, OnInit } from '@angular/core';
import * as highcharts from "highcharts";
import { Chart } from 'angular-highcharts';
import Highcharts from 'highcharts';

@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss']
})
export class DonutChartComponent implements OnInit {
  chartOptions = {}
  @Input('data')
  set in(val){
    this.plotChart(val)
  }
  highcharts = highcharts
  constructor() { }
  donutChart: Chart;
  plotChart(data) {
    return this.chartOptions = 
      {
      chart: {
        plotBorderWidth: 0,
        plotShadow: false
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      credits: {
        enabled: false
      },
       title: {
        text: ''
      },
      
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            connectorWidth: 0,
            connectorShape: 'fixedOffset',
            alignTo: 'connectors',
            format: '<b>{point.name}</b>: {point.y} %',
            
          },
         
          startAngle: -90,
          endAngle: -180,
          
          size: '90%',
          showInLegend: true
        }
        
      },
      
      legend: {
        align: 'right',
        layout: 'vertical',
        style:{
          borderLeft:"1px solid black"
        },
        verticalAlign: 'top',
        symbolPadding: 20,
        symbolWidth: 50,
        labelFormatter: function () {
          return `<div style="font-size:15px;color:#2C3A43;padding-bottom:32px;padding-right:20px;display:flex;justify-content:space-between;align-items:center;width:300px">
          <div >${this.name}</div> <div>${this.options.description}<div/></div>`
               
      },
      useHTML:true,
        x: 40,
        y: 0,
        padding:20
        },
      series: [
        {
          name: 'Defect Trends',
          dataLabels:{color:"#2C3A43",style:{fontSize:'15px'},distance:1},
          data: data.defectData,
          type: 'pie',
          innerSize: '50%',
        }]
    }
  }

  ngOnInit(): void {
  }


}